import { Drawer, DrawerContent, DrawerTitle } from "@/components/ui/drawer";
import { Calendar, Hash } from "lucide-react";

// An index card pulled from the archive.
export const SourceSheet = ({ source, onClose }) => (
  <Drawer open={!!source} onOpenChange={(o) => !o && onClose()}>
    <DrawerContent
      className="text-[#F4EFE6]"
      style={{ background: "linear-gradient(180deg, #1A1917, #121211)", borderColor: "var(--border-linen)" }}
      data-testid="source-sheet"
    >
      {source && (
        <div className="mx-auto w-full max-w-lg px-7 pb-11 pt-3">
          <p className="font-mono text-[9.5px] uppercase tracking-[0.26em]" style={{ color: "var(--lab-accent)" }}>
            from the record {source.n ? `· passage ${source.n}` : ""} · {source.type}
          </p>
          <DrawerTitle className="mt-3 font-display text-[26px] font-light leading-snug">{source.title}</DrawerTitle>

          <blockquote className="mt-6 border-l pl-5 font-display text-[19px] font-light italic leading-[1.6]" style={{ borderColor: "var(--lab-accent)", color: "var(--text-main)" }}>
            “{source.excerpt}”
          </blockquote>

          <div className="mt-7 flex flex-wrap gap-x-6 gap-y-2 border-t pt-5 font-mono text-[10px] uppercase tracking-[0.16em]" style={{ borderColor: "var(--border-linen)", color: "var(--text-faint)" }}>
            {source.date && <span className="flex items-center gap-2"><Calendar size={12} /> added {source.date}</span>}
            <span className="flex items-center gap-2"><Hash size={12} /> {source.id}</span>
            {source.score != null && <span>closeness {source.score}</span>}
          </div>

          <p className="mt-5 text-[12px] leading-relaxed" style={{ color: "var(--text-faint)" }}>
            I leaned on this passage for what I just said. Nothing beyond this Lab's own record was used.
          </p>
        </div>
      )}
    </DrawerContent>
  </Drawer>
);
